<template>
<span>
   <div class="mb-3 vx-row">
      <div id="customer_details" class="w-full vx-col">
        <vx-card>
          <div class="w-full con-expand-users">
              <div class="flex items-center justify-between con-btns-user">
                <div class="flex items-center justify-start con-userx">
                  <vs-avatar color="primary" :text="tenant && tenant.name"/>
                  <span class="font-semibold text-primary">
                    {{ tenant && tenant.name }}( {{
                      tenant && tenant.account_number
                    }} ) </span>
                </div>
              </div>
            </div>
        </vx-card>
      </div>
    </div>
  <div class="vx-row">
      <div class="w-full vx-col">
        <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none"
                 id="profile-tabs" :key="isSmallerScreen">
          <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Company profile' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <tenant-details-view :tenant="tenant"/>
              </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'L2 users' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <tenant-users/>
              </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-credit-card" :label="!isSmallerScreen ? 'Souqbox commercial' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <tenant-commercial/>
              </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-dollar-sign" :label="!isSmallerScreen ? 'Invoices' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <tenant-invoice/>
              </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-settings" :label="!isSmallerScreen ? 'Settings' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <tenant-settings-view/>
              </div>
          </vs-tab>

          <vs-tab icon-pack="feather" icon="icon-award" :label="!isSmallerScreen ? 'Branding' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                  <branding/>
              </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-hash" :label="!isSmallerScreen ? 'Number Sequence' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <number-sequence/>
              </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'RM Suppliers' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <manage-suppliers/>
              </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'Channel Partners' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <channel-partners-list/>
              </div>
          </vs-tab>
        </vs-tabs>
      </div>
  </div>
</span>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import TenantDetailsView from "@/views/pages/tenants/tabs/TenantDetailsView";
import TenantCommercial from "@/views/pages/tenants/tabs/TenantCommercial";
import TenantInvoice from "@/views/pages/tenants/tabs/TenantInvoice";
import TenantUsers from "@/views/pages/tenants/tabs/TenantUsers";
import TenantSettingsView from "@/views/pages/tenants/tabs/TenantSettingsView";
import Branding from "@/views/pages/tenants/tabs/Branding";
import NumberSequence from "@/views/pages/tenants/tabs/NumberSequence";
import ManageSuppliers from "./tabs/ManageSuppliers.vue";
import ChannelPartnersList from './tabs/ChannelPartnersList.vue'

const tenantRepository = RepositoryFactory.get('tenant')
export default {
  name: "TenantDetailsTabs",
  data () {
    return {
      active_step: this.$route.query.step ? this.$route.query.step : '0',
      tenantId: '',
      tenant: {}
    }
  },
  components : {
    Branding,
    NumberSequence,
    TenantSettingsView,
    TenantInvoice,
    TenantDetailsView,
    TenantCommercial,
    TenantUsers,
    ManageSuppliers,
    ChannelPartnersList
  },
  async mounted() {
    this.tenantId = this.$route.params.id
    await this.fetchTenant()
  },
  computed : {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  },
  methods: {
    async fetchTenant () {
      try {
        const {data} = (await tenantRepository.getTenantDetails(this.tenantId)).data;
        this.tenant = data;
        console.log("tenant details", this.tenant)
      }catch (error) {
        this.convertAndNotifyError(error)
      }
    }
  }
}
</script>

<style scoped>

</style>
